export const UNAVAILABLE_PHONE_ERROR_CODE = {
    BY_SMS: 40088,
    BY_CALL: 40089,
};

export const TYPE_OF_CONFIRM = {
    SMS: 'sms',
    CALL: 'call',
};
